"use client";

// @components
import Link from "next/link";
import { Button } from "@/components/ui/button";

export default function Error() {
  return (
    <div className="bg-background grid min-h-screen place-items-center p-6">
      <div className="text-center">
        <h1 className="mx-auto mb-4 max-w-sm text-4xl !leading-tight font-medium text-white sm:text-5xl">
          Oops, something went wrong!
        </h1>
        <p className="text-foreground mx-auto max-w-lg text-lg">
          We&apos;re sorry, but an unexpected error has occurred. Please try
          again later or contact support if the issue persists.
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-4">
          <Button asChild>
            <Link href="/">Go to Homepage</Link>
          </Button>
          <Button variant="outline">Contact Support</Button>
        </div>
      </div>
    </div>
  );
}
